import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import Main from './view/pages/main';
import store from "./common/reducer";
import { Provider } from "react-redux";
import 'view/style/css/common.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>

        <React.Fragment>
          <section className='DefaultFont'>
            <div className="content-inseide">
              <Routes>
                <Route path="/" element={<Main />} />
              </Routes>
            </div>
          </section>
        </React.Fragment>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

